import React, { useEffect, useRef } from 'react';

import { View } from '@rbilabs/universal-components';

import { routes } from 'navigation/routing';
import { t } from 'state/intl/translations';
import { useIsLoyaltyEnabled } from 'state/loyalty/hooks/use-is-loyalty-enabled';
import { isWeb } from 'utils/environment';

import SignUpHeadlineText from './sign-up-headline-text';
import {
  LogoLink,
  RewardsLinkStyled,
  SignUpHeadlineContainer,
  StyledBKLogo,
  StyledRewardsLogo,
} from './sign-up-headline.styled';

const SignUpHeadline = ({ disableLink = false }: { disableLink?: boolean }) => {
  const loyaltyEnabled = useIsLoyaltyEnabled();

  const title = t('bk_logo_title');
  const logoLinkPath = disableLink ? null : { to: routes.base };

  const rewardsLink = (
    <RewardsLinkStyled {...(!disableLink && { linkPath: routes.bkRewards })}>
      {t('royalPerks')}
    </RewardsLinkStyled>
  );

  const signUpTextRef = useRef(null);

  useEffect(() => {
    if (signUpTextRef.current && isWeb) {
      (signUpTextRef.current as HTMLElement).focus();
    }
  }, []);

  return (
    <SignUpHeadlineContainer>
      {loyaltyEnabled ? (
        <>
          <LogoLink {...logoLinkPath} focusable={false} accessible={false}>
            <StyledRewardsLogo testID="sign-up-loyalty-logo" />
          </LogoLink>
          <View focusable={false} ref={signUpTextRef}>
            <SignUpHeadlineText rewardsLink={rewardsLink} />
          </View>
        </>
      ) : (
        <LogoLink {...logoLinkPath}>
          <StyledBKLogo variant="BkLogoPrimary" title={title} testID="brand-logo" />
        </LogoLink>
      )}
    </SignUpHeadlineContainer>
  );
};

export default SignUpHeadline;
